import { useEffect, useState } from "react";
import { MemberService } from "../../services/MemberService";
import logger from "../../utils/logger";



export const UseGetMemberById = (params) => {
    const [memberToFind, setMemberToFind] = useState(null)

    const handleMemberId = (id) => {
        setMemberToFind(id)
    };

    const [memberDataById, setMemberDataById] = useState([])

    useEffect(() => {
        if (memberToFind) {
            const callMemberData = async () => {
                try {
                    const response = await MemberService.getMemberById(memberToFind)
                    if (response) {
                        setMemberDataById(response)
                    }
                } catch (error) {
                    logger.error('error de busqueda', error);

                }

            }
            callMemberData()
        }
    }, [memberToFind])

    return { memberDataById,handleMemberId }
};